module.exports = __webpack_public_path__ + "static/p-17-0766e49ec2126fb835514d2f888e0769.jpg";